/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum ResourceType {
    PLATFORM = 'platform',
    USER = 'user',
    DEAL = 'deal',
    PROGRAMME = 'programme',
    ORGANIZATION = 'organization',
}
